import { render, staticRenderFns } from "./TrueIDCard.vue?vue&type=template&id=fd6f2204&scoped=true&"
import script from "./TrueIDCard.vue?vue&type=script&lang=ts&"
export * from "./TrueIDCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6f2204",
  null
  
)

export default component.exports